export const MAX_TOPIC_NAME_LENGTH = 100
export const MAX_TOPIC_DESCRIPTION_LENGTH = 200

export const TOPIC_CARD_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
}

export const TEAM_TOPIC_STATUS = {
  ALL: 1,
  ACTIVE: 2,
  INACTIVE: 3,
}

export const getTopicStatus = (status) => {
  switch (status) {
    case 'Active':
      return 1
    case 'Inactive':
      return 0
    default:
      return null
  }
}
